/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Fc_Vs_Table_NoteInputs */

const en_fc_vs_table_note = /** @type {(inputs: Fc_Vs_Table_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Premiere Pro pricing from adobe.com (US) as of October 2026; FilmCraft data from v${i?.version}.`)
};

/**
* | output |
* | --- |
* | "Premiere Pro pricing from adobe.com (US) as of October 2026; FilmCraft data from v{version}." |
*
* @param {Fc_Vs_Table_NoteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_table_note = /** @type {((inputs: Fc_Vs_Table_NoteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Table_NoteInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_table_note(inputs)
});
export { fc_vs_table_note as "fc.vs.table.note" }